import { CalendarOutlined, ExclamationCircleOutlined, InboxOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Layout,
  message,
  Modal, notification,
  Select, Skeleton,
  Switch,
  Table,
  theme,
  TimePicker
} from "antd";
import { Content } from "antd/es/layout/layout";
import Dragger from "antd/es/upload/Dragger";
import JoditEditor from "jodit-react";
import moment from "moment";
import "moment/locale/pt-br";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  apiCreateEvent,
  apiCreateEventLogo,
  apiCreateEventTicket, apiEditEvent, apiEditEventTicket, apiDeleteEventTicket, 
  apiGetEvent,
  apiGetEventTickets,
  apiGetEventCoupons, apiCreateEventCoupon, apiEditEventCoupon, apiDeleteEventCoupon
} from "../../../../api/events";
import { ReactComponent as IncrementIcon } from "../../../../assets/images/events/increment.svg";
import { ReactComponent as Pencil } from "../../../../assets/images/events/pencil.svg";
import { ReactComponent as Copy } from "../../../../assets/images/events/copy-regular.svg";
import { ReactComponent as Question } from "../../../../assets/images/events/question.svg";
import { ReactComponent as Rocket } from "../../../../assets/images/events/rocket.svg";
import { ReactComponent as Trash } from "../../../../assets/images/events/trash.svg";
import {
  EVENT_CATEGORY_CHOICES, EVENT_DIGITAL_ADDRESS_PLATFORM_CHOICES,
  EVENT_NOMENCLATURE_CHOICES,
  EVENT_SUBJECT_CHOICES,
  EVENT_TYPE_CHOICES
} from "../../../../utils/eventsSelect";
import { formatPrice } from '../../../../utils/format';
import { searchPostalCode } from "../../../../utils/searchPostalCode";
import { states } from "../../../../utils/states";
import { useIsMobileHook } from "../../../../utils/WindowHooks";
import AddQuestions from "../AddQuestions/AddQuestions";
import TicketModal from "../TicketModal/TicketModal";
import CouponsSection from "../CouponsSection/CouponsSection";
import "./EventCreate.scss";
import dayjs from "dayjs";
import { set } from "date-fns";


const EventCreate = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const [name, setName] = useState();
  const [description, setDescription] = useState('');
  const [nameClature, setNameClature] = useState('');
  const [type, setType] = useState('IN_PERSON');
  const [category, setCategory] = useState();
  const [subject, setSubject] = useState();
  const [fileList, setFileList] = useState();
  const [isCreateButtonDisabled, setIsCreateButtonDisabled] = useState(true); // Botão começa desabilitado
  const [isLoading, setIsLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [toDeleteTickets, setToDeleteTickets] = useState([]);

  const handleEditorChange = (newContent) => {
    setDescription(newContent);
  };

  const config = {
    readonly: false,
    placeholder: 'Compartilhe todos os detalhes do seu evento, incluindo a programação e os pontos que tornam sua produção única!',
    buttons: [
      'bold', 'italic', '|', 'ul', 'ol', '|', 'fontsize', '|', 'outdent', 'indent', 'align', '|', 'hr', '|', 'fullsize', 'brush', '|', 'table', 'link', '|', 'undo', 'redo',
    ],
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 471,
    toolbarAdaptive: false,
  }

  const validateFieldsButton = () => {
    if (!name || name.trim() === '') {
      return false;
    }
    if (!description || description.trim() === '') {
      return false;
    }
    if (!subject || subject.trim() === '') {
      return false;
    }
    if (!category || category.trim() === '') {
      return false;
    }
    if (!nameClature || nameClature.trim() === '') {
      return false;
    }
    if (!address?.name_comercial || address?.name_comercial.trim() === '') {
      return false;
    }
    if (!address?.street || address?.street.trim() === '') {
      return false;
    }
    if (!address?.number || address?.number.trim() === '') {
      return false;
    }
    if (!address?.neighborhood || address?.neighborhood.trim() === '') {
      return false;
    }
    if (!address?.city || address?.city.trim() === '') {
      return false;
    }
    if (!address?.state || address?.state.trim() === '') {
      return false;
    }
    if (!address?.postal_code || address?.postal_code.trim() === '') {
      return false;
    }
    if (tickets.length === 0) {
      return false;
    }

    return true;
  };

  const parseJSON = (text) => {
    try {
      return JSON.parse(text);
    } catch (error) {
      return text;
    }
  };

  useEffect(() => {
    if (!id) {
      return
    }
    apiGetEvent(id)
      .then(async (response) => {
        const { address, digital_address, ...eventDetails } = response;

        const startDate = new Date(eventDetails.starts_at);
        const endDate = new Date(eventDetails.ends_at);

        form.setFieldsValue({
          name: eventDetails.name || "",
          description: parseJSON(eventDetails.description || ""),
          category: eventDetails.category || "",
          subject: eventDetails.subject || "",
          nameClature: eventDetails.nomenclature || "",
          type: eventDetails.type || "",
          name_comercial: address?.name || '',
          street: address?.street || '',
          number: address?.number || '',
          complement: address?.complement || '',
          neighborhood: address?.neighborhood || '',
          city: address?.city || '',
          state: address?.state || '',
          postal_code: address?.postal_code || '',
          platform: digital_address?.platform || '',
          url: digital_address?.url || '',
          other_platform: digital_address?.other_platform || '',
          start: {
            date: dayjs(startDate),
            time: dayjs(startDate).set('hour', startDate.getHours()).set('minute', startDate.getMinutes())
          },
          end: {
            date: dayjs(endDate),
            time: dayjs(endDate).set('hour', endDate.getHours()).set('minute', endDate.getMinutes())
          }
        });

        // Atualiza o estado do componente
        setName(eventDetails.name || "");
        setDescription(parseJSON(eventDetails.description) || "");
        setNameClature(eventDetails.nomenclature || "");
        setType(eventDetails.type || "");
        setCategory(eventDetails.category || "");
        setSubject(eventDetails.subject || "");

        setAddress({
          name_comercial: address?.name || '',
          street: address?.street || '',
          number: address?.number || '',
          complement: address?.complement || '',
          neighborhood: address?.neighborhood || '',
          city: address?.city || '',
          state: address?.state || '',
          postal_code: address?.postal_code || '',
        });
        setDigitalAddress({
          url: digital_address?.url || '',
          platform: digital_address?.platform || '',
          other_platform: digital_address?.other_platform || '',
        })
        setMapGoogle(address?.display_map_widget || false);
        setImageUrl(eventDetails.image_url || '');
        setIsPublic(eventDetails.public || false);
        setSellerLiable(parseInt(eventDetails.max_installments_no_tax) > 0 || false);
        setMaxInstallmentsNoTax(parseInt(eventDetails.max_installments_no_tax) || 0);
        setMaxInstallments(String(eventDetails.max_installments || "12"));
        setLimitInstallments(String(eventDetails.max_installments || "12") !== "12");
        setIsLoading(false);

        const ticketsApi = await apiGetEventTickets(id);
        if (ticketsApi && ticketsApi.results) {
          const transformTickets = (tickets) => {
            return tickets.results.map(ticket => ({
              id: ticket.id,
              name: ticket.name,
              description: ticket.description,
              amount: ticket.amount,
              questions: ticket.questions.map(q => q.prompt),
              quantity: ticket.quantity,
              sales_period_type: ticket.sales_period_type,
              sales_starts_at: ticket.sales_starts_at ? dayjs(ticket.sales_starts_at) : null,
              sales_ends_at: ticket.sales_ends_at ? dayjs(ticket.sales_ends_at) : null,
              starterQuestionList: ticket.questions.map(q => {
                const questionObject = {
                  prompt: q.prompt,
                  type: q.type
                };

                if (q.id) {
                  questionObject.id = q.id;
                }

                if (q.validation_regex) {
                  questionObject.validation_regex = q.validation_regex;
                }

                // Adiciona os values se o tipo for RADIO ou SELECT
                if (q.type === 'RADIO' || q.type === 'LIST') {
                  questionObject.values = q.values;
                }

                return questionObject;
              })
            }));
          };
          const transformedTickets = transformTickets(ticketsApi);
          setTickets(transformedTickets);
        }

        // Load existing coupons
        const couponsApi = await apiGetEventCoupons(id);
        if (couponsApi && couponsApi.results) {
          const transformedCoupons = couponsApi.results.map(coupon => ({
            id: coupon.id,
            name: coupon.name,
            code: coupon.code,
            type: coupon.type,
            value: coupon.value,
          }));
          setCoupons(transformedCoupons);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        notification.error({
          message: "Erro",
          description: "Falha ao carregar os dados do evento",
          placement: "topRight",
        });
        navigate('/eventos');
      });
  }, [id])

  // ticket
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemsQuestions, setItemsQuestions] = useState([]);
  const [starterQuestionList, setStarterQuestionList] = useState([]);
  const [questions, setQuestions] = useState([]);

  const handleNameClature = (value) => {
    setNameClature(value);
  };

  const handleCategoryChange = (value) => {
    setCategory(value);
  };

  const handleSubjectChange = (value) => {
    setSubject(value);
  };

  const validateImage = (_, value) => {
    if (value && value.length > 0) {
      return Promise.resolve();
    }
    if (imageUrl) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Por favor, selecione uma imagem."));
  };

  const buildPayload = (imageUrl) => {
    let payload = {
      name,
      description: JSON.stringify(description),
      subject,
      category,
      nomenclature: nameClature,
      type,
      starts_at: form.getFieldValue(["start", "date"]).format('YYYY-MM-DD') + 'T' + form.getFieldValue(["start", "time"]).format('HH:mm'),
      ends_at: form.getFieldValue(["end", "date"]).format('YYYY-MM-DD') + 'T' + form.getFieldValue(["end", "time"]).format('HH:mm'),
      image_url: imageUrl,
      public: isPublic,
      max_installments_no_tax: sellerLiable ? maxInstallmentsNoTax : 0,
      max_installments: limitInstallments ? maxInstallments : "12",
    }

    if (type === "IN_PERSON") {
      payload['address'] = {
        name: address?.name_comercial,
        street: address?.street,
        number: address?.number,
        complement: !address?.complement || address?.complement.trim() === "" ? "Sem Complemento": address?.complement,
        neighborhood: address?.neighborhood,
        city: address?.city,
        state: address?.state,
        postal_code: address?.postal_code,
        display_map_widget: mapGoogle,
      }
    } else if (type === "ONLINE") {
      payload['digital_address'] = {
        url: digitalAddress?.url,
        platform: digitalAddress?.platform,
        other_platform: digitalAddress?.other_platform,
      }
    }
    return payload
  }

  const handleEdit = async () => {
    let currentImageUrl = imageUrl;

    setIsLoading(true);

    try {
      if (fileList && fileList.length > 0) {
        const file = fileList[0]?.originFileObj;

        const maxSize = 2 * 1024 * 1024;

        if (file.size > maxSize) {
          message.error("A imagem é muito grande. O tamanho máximo permitido é 2MB.");
          setIsLoading(false);
          return;
        }

        try {
          const logoResponse = await apiCreateEventLogo(fileList[0].originFileObj);
          currentImageUrl = logoResponse.url;
          setImageUrl(currentImageUrl);
        } catch (uploadError) {
          message.error("Erro ao enviar a imagem. Verifique o tamanho e o formato da imagem.");
          setIsLoading(false);
          return;
        }
      }

      let payload = buildPayload(currentImageUrl);
      await apiEditEvent(id, payload);

      for (const ticket of tickets) {
        const payloadTicket = {
          name: ticket.name,
          description: ticket.description,
          amount: Math.floor(ticket.amount),
          questions: ticket.starterQuestionList,
          quantity: ticket.quantity,
          sales_period_type: ticket.sales_period_type,
          sales_starts_at: ticket.sales_starts_at,
          sales_ends_at: ticket.sales_ends_at,
        };
        if (ticket.new) {
          await apiCreateEventTicket(id, payloadTicket);
        } else {
          await apiEditEventTicket(id, ticket.id, payloadTicket);
        }
      }
      for (const ticket of toDeleteTickets) {
        if (!ticket.new) {
          await apiDeleteEventTicket(id, ticket.id);
        }
      }

      // Handle coupons
      for (const coupon of coupons) {
        const payloadCoupon = {
          name: coupon.name,
          code: coupon.code,
          type: coupon.type,
          value: coupon.value,
        };
        if (coupon.new) {
          await apiCreateEventCoupon(id, payloadCoupon);
        } else {
          await apiEditEventCoupon(id, coupon.id, payloadCoupon);
        }
      }
      for (const coupon of toDeleteCoupons) {
        if (!coupon.new) {
          await apiDeleteEventCoupon(id, coupon.id);
        }
      }

      message.success("Evento editado com sucesso!");
      navigate('/eventos');
      setIsEditing(false);

    } catch (error) {
      message.error("Erro ao editar o evento. Verifique os detalhes e tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!fileList[0]) {
      message.error("Nenhum arquivo foi selecionado.");
      return;
    }
    setIsLoading(true);

    const file = fileList[0]?.originFileObj;

    const maxSize = 2 * 1024 * 1024;

    if (file.size > maxSize) {
      message.error("A imagem é muito grande. O tamanho máximo permitido é 2MB.");
      setIsLoading(false);
      return;
    }

    try {
      let imageUrl = "";
      try {
        const logoResponse = await apiCreateEventLogo(fileList[0]?.originFileObj);
        imageUrl = logoResponse.url;
      } catch (uploadError) {
        message.error("Erro ao enviar a imagem. Verifique o tamanho e o formato da imagem.");
        setIsLoading(false);
        return;
      }

      const payload = buildPayload(imageUrl);

      const eventJSON = await apiCreateEvent(payload);

      for (const ticket of tickets) {
        const payloadTicket = {
          name: ticket.name,
          description: ticket.description,
          amount: Math.floor(ticket.amount),
          questions: ticket.starterQuestionList,
          quantity: ticket.quantity,
          sales_period_type: ticket.sales_period_type,
          sales_starts_at: ticket.sales_starts_at,
          sales_ends_at: ticket.sales_ends_at,
        };

        await apiCreateEventTicket(eventJSON.id, payloadTicket);
      }

      // Create coupons
      for (const coupon of coupons) {
        const payloadCoupon = {
          name: coupon.name,
          code: coupon.code,
          type: coupon.type,
          value: coupon.value,
        };

        await apiCreateEventCoupon(eventJSON.id, payloadCoupon);
      }

      setIsLoading(false);
      message.success("Evento criado com sucesso!");
      navigate('/eventos');
    } catch (error) {
      console.log(error)
      setIsLoading(false);
      message.error("Erro ao criar evento.");
    }
  };

  const [form] = Form.useForm();
  const onFinish = () => {
    form
      .validateFields()
      .then(() => {
        if (!description || description.trim() === '') {
          message.error("Por favor, insira a descrição.");
          return;
        }
        if (tickets.length === 0) {
          message.error("Por favor, adicione pelo menos um ticket.");
          return;
        }
        id ? handleEdit() : handleSubmit();
      })
      .catch(() => {
        message.error("Preencha todos os campos obrigatórios.");
      });
  };

  // ADDRESS
  const [address, setAddress] = useState({
    name_comercial: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    postal_code: '',
  });

  const [digitalAddress, setDigitalAddress] = useState({
    url: '',
    platform: '',
    other_platform: '',
  })

  useEffect(() => {
    if (address.postal_code.length === 8) {
      checkPostalCode(address.postal_code);
    }
  }, [address.postal_code]);

  const checkPostalCode = (number) => {
    searchPostalCode(number, (data) => {
      if (data && !data.erro) {
        const updatedAddress = {
          name_comercial: address.name_comercial,
          street: data.logradouro,
          number: address.number,
          complement: address.complement,
          neighborhood: data.bairro,
          city: data.localidade,
          state: data.uf,
          postal_code: data.cep,
        };

        setAddress(updatedAddress);
        form.setFieldsValue(updatedAddress);
      } else {
        message.error("CEP não encontrado. Preencha manualmente.");
      }
    });
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddress(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDigitalAddressChange = (e) => {
    const { name, value } = e.target;
    setDigitalAddress(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  // TODO TICKET
  const addQuestion = () => {
    const questionList = [...starterQuestionList, ""];
    setStarterQuestionList(questionList);
  };

  const handleSaveQuestions = () => {
    if (selectedItem && tickets.length > 0) {
      const updatedItem = { ...selectedItem, starterQuestionList };
      const updatedItems = tickets.map(item =>
        item.id === updatedItem.id ? updatedItem : item
      );
      setItemsQuestions(updatedItems);
      setTickets(updatedItems);
    }

    setIsModalQuestionsVisible(false);
  };


  const handleUploadChange = (info) => {
    const newFileList = info.fileList.slice(-1);
    setFileList(newFileList);

    if (info.file.status === "done") {
      message.success(`${info.file.name} arquivo carregado com sucesso`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} falha no carregamento`);
    }
  };

  // TICKETS
  const [tickets, setTickets] = useState([]);
  const [isFree, setIsFree] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalQuestionsVisible, setIsModalQuestionsVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingTicketId, setEditingTicketId] = useState(null);
  const [internalAmount, setInternalAmount] = useState("");
  const [editingTicket, setEditingTicket] = useState(null);

  // COUPONS
  const [coupons, setCoupons] = useState([]);
  const [toDeleteCoupons, setToDeleteCoupons] = useState([]);

  // EXTRA OPTIONS
  const [isPublic, setIsPublic] = useState(true);
  const [sellerLiable, setSellerLiable] = useState(false);
  const [maxInstallmentsNoTax, setMaxInstallmentsNoTax] = useState(0);
  const [maxInstallments, setMaxInstallments] = useState("12");
  const [limitInstallments, setLimitInstallments] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);

  const openModalToEdit = (ticket) => {
    setIsEditing(true);
    setEditingTicketId(ticket.id);
    setEditingTicket(ticket)
    setInternalAmount(ticket.amount)
    setQuestions(ticket.questions || []);
    setStarterQuestionList(ticket.starterQuestionList || []);
    setIsModalVisible(true);
  };

  const openModalQuestions = (record) => {
    setSelectedItem(record);
    setStarterQuestionList(record.starterQuestionList || []);
    setIsModalQuestionsVisible(true);
  };

  const handleDeleteTicket = (record) => {
    setToDeleteTickets(prev => [...prev, record]);
    const updatedTickets = tickets.filter(ticket => ticket.id !== record.id);
    setTickets(updatedTickets);
    setIsModalVisible(false);
  };

  const showDeleteConfirm = (record) => {
    Modal.confirm({
      title: 'Tem certeza que deseja excluir esse ingresso?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sim',
      okType: 'primary',
      cancelText: 'Não',
      className: 'custom-delete-modal',
      onOk() {
        handleDeleteTicket(record);
      },
      onCancel() {
        console.log('Cancelado');
      },
    });
  };

  const duplicateTicket = (record) => {
    // Cria uma cópia do ticket
    let newTicket = record;
    setTickets([
      ...tickets,
      {
        id: new Date().getTime(),
        name: newTicket.name,
        description: newTicket.description,
        amount: newTicket.amount,
        questions: newTicket.questions.slice(0),
        starterQuestionList: [],
        quantity: newTicket.quantity,
        sales_period_type: newTicket.sales_period_type,
        sales_starts_at: newTicket.sales_starts_at ? dayjs(newTicket.sales_starts_at) : null,
        sales_ends_at: newTicket.sales_ends_at ? dayjs(newTicket.sales_ends_at) : null,
        new: true,
      },
    ]);
  }

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Valor',
      dataIndex: 'amount',
      key: 'price',
      render: (amount) => (
        <p className="ticket-price">{formatPrice(amount / 100)}</p>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div className="ticket-actions">
          <Copy role="button" onClick={() => duplicateTicket(record)} className="button-ticket" />
          <Pencil role="button" onClick={() => openModalToEdit(record)} className="button-ticket" />
          <Trash role="button" onClick={() => showDeleteConfirm(record)} className="button-ticket" />
          <button onClick={() => openModalQuestions(record)} className="button-ticket-completed">
            Configurar questionário
            <Question />
          </button>
        </div>
      ),
      responsive: ["md"],
    },
  ];

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const isMobile = useIsMobileHook(1500);
  const handleRowClick = (record) => {
    const id = record.id;
    if (expandedRowKeys.includes(id)) {
      setExpandedRowKeys(expandedRowKeys.filter(key => key !== id));
    } else {
      setExpandedRowKeys([id]);
    }
  };

  const expandedRowRender = (record) => (
    <div className="expandid">
      <div className="ticket-actions">
        <Copy role="button" onClick={() => duplicateTicket(record)} className="button-ticket" />
        <Pencil role="button" onClick={() => openModalToEdit(record)} className="button-ticket" />
        <Trash role="button" onClick={() => showDeleteConfirm(record)} className="button-ticket" />
        <button onClick={() => openModalQuestions(record)} className="button-ticket-completed">
          Configurar questionário
          <Question />
        </button>
      </div>
    </div>
  );

  const props = {
    name: "file",
    multiple: false,
    onChange: handleUploadChange,
    maxCount: 1,
    accept: ".jpeg,.jpg,.png,.gif",
    style: { width: '100%' },
    beforeUpload: () => false,
  };

  const dateFormat = "DD/MM/YYYY";
  const timeFormat = 'HH:mm';
  moment.locale("pt-br");

  const [mapGoogle, setMapGoogle] = useState(false);

  const onChangeMap = (checked) => {
    setMapGoogle(checked);
  }

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setEditingTicket(null)
  };


  const openModal = () => {
    setIsModalVisible(true);
    setIsEditing(false);
  };

  useEffect(() => {
    const isValid = validateFieldsButton();
    setIsCreateButtonDisabled(!isValid);
  }, [name, description, subject, category, nameClature, address, tickets]);


  return (
    <div className="EventCreate">
      <Helmet>
        <title>Clap Tickets - Criação de Evento</title>
      </Helmet>
      <div className="type-event-info">
        {!isLoading ? <p>{id ? name : "Evento " + state?.type}</p> : <p>Carregando</p>}
      </div>
      <Layout
        style={{
          padding: "0 1.25rem",
          position: "relative",
        }}
      >
        <Content
          className="content-event"
          style={{
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          {isLoading && <Skeleton active paragraph={{ rows: 4 }} />}
          {isLoading && <Skeleton active paragraph={{ rows: 4 }} />}
          <Breadcrumb
            className="breadcrumb-title"
          >
            {!isLoading && <>
              <Breadcrumb.Item >Meus eventos</Breadcrumb.Item>
              <Breadcrumb.Item >Criar evento {state?.type.toLowerCase()}</Breadcrumb.Item>
            </>
            }
          </Breadcrumb>
          {!isLoading &&<div className="title">
            <p>Informações do seu evento</p>
          </div>}
          {!isLoading && <div className="CreateEvent-content">
            <div className="left">
              <div className="event-form-container">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className="event-form">
                  <Form.Item
                    hasFeedback={true}
                    label="Nome do Evento"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira o nome do link.",
                      },
                      {max: 100}, {min: 3}
                    ]}
                  >
                    <Input
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </Form.Item>
                  <div className="event-form-row">

                    <Form.Item
                      label="Categoria"
                      name="category"
                      rules={[
                        {
                          required: true,
                          message: "Por favor, selecione a categoria.",
                        },
                      ]}
                    >
                      <Select
                        value={category}
                        onChange={handleCategoryChange}
                        placeholder="Selecione a categoria"
                      >
                        {EVENT_CATEGORY_CHOICES.map((item) => (
                          <Select.Option key={item.value} value={item.value}>
                            {item.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Assunto"
                      name="subject"
                      rules={[
                        {
                          required: true,
                          message: "Por favor, selecione o assunto.",
                        },
                      ]}
                    >
                      <Select
                        value={subject}
                        onChange={handleSubjectChange}
                        placeholder="Selecione o assunto"
                      >
                        {EVENT_SUBJECT_CHOICES.map((item) => (
                          <Select.Option key={item.value} value={item.value}>
                            {item.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>


                  </div>
                  <Form.Item
                    label="Nomenclatura"
                    name="nameClature"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, selecione a nomenclatura.",
                      },
                    ]}
                  >
                    <Select
                      value={nameClature}
                      onChange={handleNameClature}
                    >
                      {EVENT_NOMENCLATURE_CHOICES.map((item) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <div className="image-response">
                    <Form form={form} layout="vertical" style={{ width: "100%" }}>
                      <Form.Item
                        label="Imagem de Divulgação"
                        name="eventImage"
                        valuePropName="fileList"
                        rules={[
                          {
                            required: true,
                            message: "Por favor, selecione uma imagem.",
                            validator: validateImage
                          },
                        ]}
                        getValueFromEvent={({ fileList }) => fileList}
                      >
                        <Dragger
                          {...props}>
                          {(fileList && fileList.length > 0 && fileList[0].originFileObj) || imageUrl ? (
                            <img
                              src={(fileList?.length > 0 && URL.createObjectURL(fileList?.[0].originFileObj)) || imageUrl}
                              alt="preview"
                              style={{ width: '100%', maxHeight: '200px', objectFit: 'cover' }}
                            />
                          ) : (
                            <>
                              <p className="ant-upload-drag-icon">
                                <InboxOutlined style={{ fontSize: "32px", color: "#1890ff" }} />
                              </p>
                              <p className="ant-upload-text">Clique ou arraste a imagem aqui</p>
                              <p className="ant-upload-hint">
                                JPEG, GIF ou PNG <br /> máximo <strong>2MB</strong>
                              </p>
                            </>
                          )}
                        </Dragger>
                      </Form.Item>
                    </Form>
                  </div>
                  <div className="event-form-row date-time-pickers">
                    <div className="date-time-group">
                      <Form.Item
                        label="Início"
                      >
                        <div className="date-time-field">
                          <CalendarOutlined className="custom-icon" />
                          <Form.Item name={["start", "date"]} noStyle
                             rules={[{ required: true, message: 'Por favor, insira uma data de início' }]}
                             hasFeedback={true}
                          >
                            <DatePicker
                              format={{ format: dateFormat, type: 'mask' }}
                              placeholder="Data"
                              needConfirm={false}
                            />
                          </Form.Item>
                          <Form.Item name={["start", "time"]} noStyle
                             rules={[{ required: true, message: 'Por favor, insira uma hora de início' }]}
                             hasFeedback={true}
                            >
                            <TimePicker
                              use12Hours={false}
                              format={{ format: timeFormat, type: 'mask' }}
                              placeholder="Horário"
                              needConfirm={false}
                            />
                          </Form.Item>
                        </div>
                      </Form.Item>
                    </div>
                    <div className="date-time-group">
                      <Form.Item
                        label="Término"
                      >
                        <div className="date-time-field">
                          <CalendarOutlined className="custom-icon" />
                          <Form.Item name={["end", "date"]} noStyle
                             rules={[{ required: true, message: 'Por favor, insira uma data de fim' }]}
                             hasFeedback={true}
                          >
                            <DatePicker
                              format={{ format: dateFormat, type: 'mask' }}
                              placeholder="Data"
                              needConfirm={false}
                            />
                          </Form.Item>

                          <Form.Item name={["end", "time"]} noStyle
                             rules={[{ required: true, message: 'Por favor, insira uma hora de fim' }]}
                             hasFeedback={true}
                          >
                            <TimePicker
                              use12Hours={false}
                              format={{ format: timeFormat, type: 'mask' }}
                              placeholder="Horário"
                              needConfirm={false}
                            />
                          </Form.Item>
                        </div>
                      </Form.Item>
                    </div>

                  </div>

                </Form>
              </div>

              <div className="container-width" style={{ marginTop: 30 }}>
                <label className="required">Descrição</label>
                <JoditEditor
                  value={description}
                  config={config}
                  onBlur={handleEditorChange}
                  onChange={(newContent) => { }}
                />
              </div>
            </div>
            <div className="right">
              <div className="image-response">
                <Form form={form} layout="vertical" style={{ width: "100%" }}>
                  <Form.Item
                    label="Imagem de Divulgação"
                    name="eventImage"
                    valuePropName="fileList"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, selecione uma imagem.",
                        validator: validateImage
                      },
                    ]}
                    getValueFromEvent={({ fileList }) => fileList}
                  >
                    <Dragger
                      {...props}>
                      {(fileList && fileList.length > 0 && fileList[0].originFileObj) || imageUrl ? (
                        <img
                          src={(fileList?.length > 0 && URL.createObjectURL(fileList?.[0].originFileObj)) || imageUrl}
                          alt="preview"
                          style={{ width: '100%', maxHeight: '200px', objectFit: 'cover' }}
                        />
                      ) : (
                        <>
                          <p className="ant-upload-drag-icon">
                            <InboxOutlined style={{ fontSize: "32px", color: "#1890ff" }} />
                          </p>
                          <p className="ant-upload-text">Clique ou arraste a imagem aqui</p>
                          <p className="ant-upload-hint">
                            JPEG, GIF ou PNG <br /> máximo <strong>2MB</strong>
                          </p>
                        </>
                      )}
                    </Dragger>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>}
        </Content>
        {!isLoading && <div className="divider"></div>}
        {!isLoading && <Content
          className="content-event"
          style={{
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="CreateEvent-content">
            <div className="left">
              <div className="event-form-location">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className="event-form"
                >
                  <div className="title-container">
                    <p>Onde o seu evento vai acontecer?</p>
                  </div>

                  <Form.Item
                    label="Onde será seu evento?"
                    name="type"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, selecione um tipo.",
                      },
                    ]}
                  >
                    <Select
                      value={type}
                      onChange={(type) => setType(type)}
                    >
                      {EVENT_TYPE_CHOICES.map((item) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {type === "ONLINE" &&
                    <>
                      <div className="distribution-two">
                        <Form.Item
                          label="Qual será a plataforma?"
                          name="platform"
                          rules={[
                            {
                              required: true,
                              message: "Por favor, selecione uma plataforma.",
                            },
                          ]}
                        >
                          <Select
                            value={digitalAddress.platform}
                            onChange={(e) => {
                              setDigitalAddress({
                                ...digitalAddress,
                                platform: e,
                              });
                            }
                            }
                          >
                            {EVENT_DIGITAL_ADDRESS_PLATFORM_CHOICES.map((item) => (
                              <Select.Option key={item.value} value={item.value}>
                                {item.label}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {digitalAddress.platform === "OTHER" &&
                          <Form.Item
                            hasFeedback={true}
                            label="Qual o nome da plataforma?"
                            name="other_platform"
                            rules={[{required: true, message: 'Por favor, insira o nome da plataforma.'}, {min: 3}, {max: 100}]}
                          >
                            <Input
                              name="other_platform"
                              value={digitalAddress.other_platform}
                              onChange={handleDigitalAddressChange}
                            />
                          </Form.Item>
                        }
                      </div>
                      <Form.Item
                        hasFeedback={true}
                        label="URL"
                        name="url"
                        rules={[{ required: true, message: 'Por favor, insira uma URL.' }, {min: 3}, {max: 512}]}
                      >
                        <Input
                          name="url"
                          value={digitalAddress.url}
                          onChange={handleDigitalAddressChange}
                        />
                      </Form.Item>
                    </>
                  }

                  {type === "IN_PERSON" &&
                    <>
                      <Form.Item
                        hasFeedback={true}
                        label="Nome do local"
                        name="name_comercial"
                        rules={[{ required: true, message: 'Por favor, insira o nome do local.' }, {min: 3}, {max: 100}]}
                      >
                        <Input
                          name="name_comercial"
                          value={address.name_comercial}
                          onChange={handleAddressChange}
                        />
                      </Form.Item>
                      <div className="distribution-three">
                        <Form.Item
                          label="CEP"
                          name="postal_code"
                          rules={[{ required: true, message: 'Por favor, insira o CEP.' }, {max: 32}]}
                        >
                          <Input
                            name="postal_code"
                            placeholder="00000-00"
                            value={address.postal_code}
                            onChange={handleAddressChange}
                          />
                        </Form.Item>
                        <Form.Item
                          label="Logradouro"
                          name="street"
                          rules={[{ required: true, message: 'Por favor, insira a Logradouro.' }, {max: 100}]}
                        >
                          <Input
                            name="street"
                            value={address.street}
                            onChange={handleAddressChange}
                          />
                        </Form.Item>
                        <Form.Item
                          label="Número"
                          name="number"
                          rules={[{ required: true, message: 'Por favor, insira o número.' }, {max: 100}]}
                        >
                          <Input
                            name="number"
                            value={address.number}
                            onChange={handleAddressChange}
                          />
                        </Form.Item>
                      </div>
                      <div className="distribution-two">
                        <Form.Item
                          label="Bairro"
                          name="neighborhood"
                          rules={[{ required: true, message: 'Por favor, insira o bairro.' }, {max: 100}]}
                        >
                          <Input
                            name="neighborhood"
                            value={address.neighborhood}
                            onChange={handleAddressChange}
                          />
                        </Form.Item>
                        <Form.Item
                          label="Cidade"
                          name="city"
                          rules={[{ required: true, message: 'Por favor, insira a cidade.' }, {max: 100}]}
                        >
                          <Input
                            name="city"
                            value={address.city}
                            onChange={handleAddressChange}
                          />
                        </Form.Item>
                      </div>
                      <div className="distribution-finish">
                        <Form.Item
                          label="Estado"
                          name="state"
                          rules={[{ required: true, message: 'Por favor, selecione o estado.' }]}
                        >
                          <Select
                            value={address.state}
                            onChange={(value) => setAddress(prevState => ({
                              ...prevState,
                              state: value
                            }))}
                            placeholder="Selecione o estado"
                          >
                            {states.map((state) => (
                              <Select.Option key={state.code} value={state.code}>
                                {state.code} - {state.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          label="Complemento"
                          name="complement"
                          rules={[{ required: false, message: 'Por favor, insira o complemento.' }, {max: 100}]}
                        >
                          <Input
                            name="complement"
                            value={address.complement}
                            onChange={handleAddressChange}
                          />
                        </Form.Item>
                      </div>
                      <div className="switch-map">
                        <Switch label="Ativo" checked={mapGoogle} onChange={onChangeMap} />
                        <p>Mostrar o endereço no Google Maps</p>
                      </div>
                    </>
                  }
                </Form>
              </div>
            </div>
            <div className="right" />
          </div>
        </Content>}
        {!isLoading && <div className="divider"></div>}
        {!isLoading && <Content
          className="content-event"
          style={{
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="CreateEvent-content">
            <div className="left completed">
              <div className="container-button">
                <div className="title-and-button">
                  <div className="title-container">
                    <p>Ingressos, tickets</p>
                  </div>
                  {tickets.length > 0 &&
                    <Button onClick={openModal} className="custom-btn">
                      <IncrementIcon /> Criar um ingresso
                    </Button>
                  }
                </div>

                {tickets.length === 0 && <div className="empty-tickets">
                  <Button onClick={openModal} className="custom-btn">
                    <IncrementIcon /> Criar um ingresso
                  </Button>
                </div>}
                {tickets.length > 0 && <Table
                  tableLayout="fixed"
                  columns={columns}
                  dataSource={tickets}
                  rowKey="id"
                  expandable={{
                    expandedRowRender: isMobile ? expandedRowRender : undefined,
                    expandedRowKeys: expandedRowKeys,
                    onExpand: (expanded, record) => handleRowClick(record),
                    responsive: ["xl"],
                  }}
                />}
              </div>
            </div>
          </div>
        </Content>}
        {!isLoading && <div className="divider"></div>}
        {!isLoading && <Content
          className="content-event"
          style={{
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="CreateEvent-content">
            <div className="left completed">
              <CouponsSection
                eventId={id}
                coupons={coupons}
                setCoupons={setCoupons}
                toDeleteCoupons={toDeleteCoupons}
                setToDeleteCoupons={setToDeleteCoupons}
              />
            </div>
          </div>
        </Content>}
        {!isLoading && <div className="divider"></div>}
        {!isLoading && <Content
          className="content-event"
          style={{
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="CreateEvent-content">
            <div className="left completed">
              <div className="container-button">
                <div className="title-container">
                  <p>Opções Extras</p>
                </div>

                <div style={{ marginTop: '20px' }}>
                  <Checkbox
                    checked={isPublic}
                    onChange={(e) => setIsPublic(e.target.checked)}
                  >
                    Evento Público
                  </Checkbox>
                  <div style={{ marginLeft: '24px', marginTop: '2px', marginBottom: '12px' }}>
                    <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                      Eventos Públicos aparecem na página inicial da ClapTickets
                    </span>
                  </div>

                  <Checkbox
                    checked={limitInstallments}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setLimitInstallments(true);
                        setMaxInstallments("12");
                      } else {
                        setLimitInstallments(false);
                      }
                    }}
                  >
                    Limitar número de parcelas
                  </Checkbox>
                  <div style={{ marginLeft: '24px', marginTop: '2px' }}>
                    <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                      Define um número máximo de parcelas a ser exibido no checkout
                    </span>
                  </div>
                  {limitInstallments && (
                    <div style={{ marginLeft: '24px', marginTop: '12px', marginBottom: '12px' }}>
                      <span style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '4px' }}>
                        Máximo de parcelas
                      </span>
                      <Select
                        value={maxInstallments}
                        onChange={(value) => setMaxInstallments(value)}
                        style={{ width: '200px' }}
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => (
                          <Select.Option key={n} value={String(n)}>
                            {n}x
                          </Select.Option>
                        ))}
                      </Select>
                      <div style={{ marginTop: '4px', maxWidth: '480px' }}>
                        <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                          Independente do máximo configurado, o valor mínimo de cada parcela é de R$ 5,00. Em compras de valor mais baixo, o número de parcelas pode ser automaticamente reduzido pelo sistema.
                        </span>
                      </div>
                    </div>
                  )}

                  <Checkbox
                    checked={sellerLiable}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setIsConfirmModalVisible(true);
                      } else {
                        setSellerLiable(false);
                      }
                    }}
                  >
                    Assumir as taxas do evento
                  </Checkbox>
                  <div style={{ marginLeft: '24px', marginTop: '2px' }}>
                    <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                      Ao assumir as taxas, você deixa de receber o valor integral das vendas
                    </span>
                  </div>
                  {sellerLiable && (
                    <div style={{ marginLeft: '24px', marginTop: '12px' }}>
                      <span style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '4px' }}>
                        Até quantas parcelas deseja assumir a taxa?
                      </span>
                      <Select
                        value={maxInstallmentsNoTax}
                        onChange={(value) => setMaxInstallmentsNoTax(value)}
                        style={{ width: '200px' }}
                        placeholder="Selecione o número de parcelas"
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => (
                          <Select.Option key={n} value={n}>
                            {n}x
                          </Select.Option>
                        ))}
                      </Select>
                      <div style={{ marginTop: '4px' }}>
                        <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                          Você assumirá a taxa de parcelamento para compras em até {maxInstallmentsNoTax || 0} parcelas
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Content>}
        <div className="container-buttons">
          <Button
            onClick={onFinish}
            danger
            className="button-create-close"
          >
            Cancelar
          </Button>
          <Button
            onClick={onFinish}
            // disabled={isCreateButtonDisabled}
            loading={isLoading}
            type="primary"
            className="button-create-event"
          >
            <Rocket /> {id ? "Salvar evento" : "Publicar evento"}
          </Button>
        </div>
      </Layout >
      <TicketModal
        eventID={id}
        visible={isModalVisible}
        onClose={handleCloseModal}
        setIsModalVisible={setIsModalVisible}
        isEditing={isEditing}
        setTickets={setTickets}
        tickets={tickets}
        setEditingTicketId={setEditingTicketId}
        editingTicketId={editingTicketId}
        editingTicket={editingTicket}
      />

      <Modal
        open={isModalQuestionsVisible}
        className="ticket-modal"
        onCancel={() => setIsModalQuestionsVisible(false)}
        footer={[
          <Button className='button-modal' key="cancel" danger onClick={() => setIsModalQuestionsVisible(false)}>
            Cancelar
          </Button>,
          <Button className='button-modal' key="submit" type="primary" onClick={() => handleSaveQuestions()}>
            Salvar perguntas
          </Button>
        ]}
      >
        <h2 className="ant-modal-title">Perguntas de cadastro na compra</h2>
        <AddQuestions
          starterQuestionList={starterQuestionList}
          setStarterQuestionList={setStarterQuestionList}
          questions={starterQuestionList}
        />
        <Button className="button-add-question" onClick={addQuestion}><PlusOutlined />Adicionar nova pergunta</Button>
      </Modal>

      <Modal
        open={isConfirmModalVisible}
        title="Você tem certeza?"
        onCancel={() => setIsConfirmModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsConfirmModalVisible(false)}>
            Cancelar
          </Button>,
          <Button
            key="confirm"
            type="primary"
            onClick={() => {
              setSellerLiable(true);
              setMaxInstallmentsNoTax(12);
              setIsConfirmModalVisible(false);
            }}
          >
            Confirmar
          </Button>
        ]}
      >
        <p>
          Ao optar por assumir as taxas, você está ciente de que o valor a receber pela venda dos ingressos será deduzido das tarifas de processamento aplicadas pela empresa de pagamento.
        </p>
      </Modal>
    </div >
  );
};

export default EventCreate;